module.exports = __webpack_public_path__ + "media/images/icons/flags/GG-25552d4d99aaeb418a9c2642be1c39a4.svg";